module.exports = __webpack_public_path__ + "img/effect2.e62d6bb3.svg";